<template>
  <div class="page_content ">
    <div class="faq_welcome">
      <div class="welc_cont">
        <div class="row justify-content-center">
          <div class="col-12">
            <h1>Veelgestelde vragen</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="faq_content">
      <div class="faq_box">
        <div class="accordion_section">

          <div class="title_accordion">
            <h1>Prepaid Suprise algemeen</h1>
          </div>

          <div class="accord_outer" id="accordion_1">
            <div class="accord_title">
              <a class="d-flex flex-row justify-content-between align-items-center" data-toggle="collapse" data-parent="#accordion_1"  href="#collapse_1_1">
                <p>Wat is Prepaid Surprise?</p>
                <i class="fa fa-chevron-down"></i>
              </a>
            </div>
            <div id="collapse_1_1" class="collapse">
              <div class="accord_body">
                <p>Prepaid Surprise is het online spel voor Odido Prepaid gebruikers.</p>
                <br>
                <p>Elke keer dat je opwaardeert of via iDEAL een <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank" rel="noopener">bundel</a> koopt van minimaal € 7,50, krijg je binnen een half uur een sms met je unieke speelcode voor Prepaid Surprise. Hiermee kun je het Prepaid Surprise-spel spelen en fantastische hoofdprijzen winnen. Geen hoofdprijs gewonnen? Niet getreurd, je krijgt namelijk altijd nog een surprise naar keuze! Kies uit bijvoorbeeld gratis sms'jes, MB’s of belminuten!</p>
                <br>
                <p>Hoe het spel precies werkt lees je
                  <router-link to="HowItWorks">hier</router-link>
                  .
                </p>
              </div>

              <div class="" id="accordion1_2">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion1_2"
                     href="#collapse_1_2">
                    <p>Hoe speel ik mee met Prepaid Surprise?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_1_2" class="collapse in">
                  <div class="accord_body">
                    <p>Elke keer dat je opwaardeert of via iDEAL een <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank" rel="noopener">bundel</a> koopt van minimaal € 7,50, krijg je binnen een half uur een sms met je unieke speelcode voor Prepaid Surprise. Heb je een smartphone? Klik op de link om direct naar Prepaid Surprise te gaan en te spelen. Je mobiele nummer en speelcode worden automatisch ingevuld, zo kun je direct het spel spelen. Daarnaast is de Prepaid Surprise pagina gratis te bezoeken via je smartphone. Dit gaat dus niet af van je Prepaid tegoed.</p>
                    <br>
                    <p>Heb je geen smartphone? Ga dan op je computer <router-link to="Home">www.prepaidsurprise.odido.nl</router-link>, vul je mobiele nummer in en je speelcode en volg de aanwijzingen op de website. Na het spelen zie je direct of je iets gewonnen hebt.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion1_3">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion1_3"
                     href="#collapse_1_3">
                    <p>Hoeveel draaien aan het rad kan ik krijgen?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_1_3" class="collapse in">
                  <div class="accord_body">
                    <p>Hoe vaak je kan draaien, hangt af van je opwaardeerbedrag én hoe goed je het spel speelt.</p>
                    <br>
                    <ul>
                      <li>Als je je tegoed opwaardeert met een bedrag tussen € 10 en € 15, mag je één keer aan het rad draaien en staat er één hoofdprijs op het rad.</li>
                      <li>Waardeer je je tegoed op met een bedrag tussen € 15 en € 20, dan mag je één keer aan het rad draaien en staan er twee hoofdprijzen op het rad.</li>
                      <li>Bij een opwaardering van meer dan € 20 of koop je via iDEAL de volgende <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank" rel="noopener">bundel</a>: Combi L, Combi XL, Combi XXL of Combi Unlimited, dan mag je twee keer aan het rad draaien en staan er drie hoofdprijzen op het rad.</li>
                      <li>Koop je via iDEAL een bundel van minimaal € 7,50, dan kun je één keer aan het rad draaien en staat er één hoofdprijs op het rad.</li>
                    </ul>
                    <br>
                    <p>Meer informatie over de bundels vind je <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank" rel="noopener">hier</a>.</p>
                    <br>
                    <p>Hoe het spel precies werkt lees je
                      <router-link to="HowItWorks">hier</router-link>.
                    </p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion1_4">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion1_4"
                     href="#collapse_1_4">
                    <p>Hoe kan ik meedoen aan Prepaid Surprise?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_1_4" class="collapse in">
                  <div class="accord_body">
                    <p>Elke keer dat je vanaf € 10 opwaardeert of via iDEAL een bundel koopt van minimaal € 7,50, krijg je een speelcode voor Prepaid Surprise. Maar let op: hoe hoger je opwaardeerbedrag hoe meer kans je maakt op het winnen van 1 van de fantastische prijzen.</p>
                    <br>
                    <ul>
                      <li>Als je je tegoed opwaardeert met een bedrag tussen € 10 en € 15, mag je één keer aan het rad draaien en staat er één hoofdprijs op het rad.</li>
                      <li>Waardeer je je tegoed op met een bedrag tussen € 15 en € 20, dan mag je één keer aan het rad draaien en staan er twee hoofdprijzen op het rad.</li>
                      <li>Bij een opwaardering van meer dan € 20 of koop je via iDEAL de volgende <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank" rel="noopener">bundels</a>: Combi L, Combi XL, Combi XXL of Combi Unlimited, dan mag je twee keer aan het rad draaien en staan er drie hoofdprijzen op het rad.</li>
                      <li>Koop je via iDEAL een <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank" rel="noopener">bundel</a> van minimaal € 7,50 en minder dan € 20, dan kun je één keer aan het rad draaien en staat er één hoofdprijs op het rad.</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="" id="accordion1_5">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion1_5"
                     href="#collapse_1_5">
                    <p>Hoe groot is de kans dat ik win?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_1_5" class="collapse in">
                  <div class="accord_body">
                    <p>Als je meespeelt met de speelcode die je hebt gekregen, win je altijd. Gegarandeerd. Heb je namelijk geen hoofdprijs gewonnen, dan kun je altijd een surprise uitkiezen. Dit kunnen bijvoorbeeld extra sms'jes, MB’s of belminuten zijn.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion1_6">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion1_6"
                     href="#collapse_1_6">
                    <p>Hoe kan ik mij afmelden voor Prepaid Surprise?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_1_6" class="collapse in">
                  <div class="accord_body">
                    <p>Om je af te melden, log je eerst in op MySurprise.
                    <p>Onderaan de pagina zie je de link Afmelden voor Prepaid Surprise. Wanneer je daarop klikt word je afgemeld en zul je na je opwaarderingen geen Prepaid Surprise speelcodes meer ontvangen.</p>
                    <br>
                    <p>Heb je geen MySurprise account? Klik dan <a href="#"
                                                                   @click.prevent="goToOptOut()">hier</a>
                      hier en geef je mobiele nummer op en een speelcode (oud of nieuw) om je af te melden.
                    </p>
                    <p>Mocht je later weer mee willen spelen hoef je je alleen weer aan te melden. Dit doe je door een MySurprise account aan te maken.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion1_7">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion1_7"
                     href="#collapse_1_7">
                    <p>Ik heb me per ongeluk afgemeld bij Prepaid Surprise. Hoe meld ik me opnieuw aan?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_1_7" class="collapse in">
                  <div class="accord_body">
                    <p>Om je opnieuw aan te melden hoef je alleen een MySurprise account aan te maken. Klik <a href="#" @click.prevent="registerPopup()">hier</a> om je account aan te maken. Of stuur je een sms met het woord: aanmelden naar 1616.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion1_8">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion1_8"
                     href="#collapse_1_8">
                    <p>Ik wil Prepaid Surprise spelen via mijn smartphone en/of tablet maar ben bang voor internetkosten.</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_1_8" class="collapse in">
                  <div class="accord_body">
                    <p>Geen zorgen, de Prepaid Surprise pagina is voor Odido Prepaid klanten gratis te bezoeken. Er gaat dus niets af van je Prepaid tegoed.</p>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="accord_outer" id="accordion_2">
            <div class="accord_title">
              <a class="d-flex flex-row justify-content-between align-items-center"
                 data-toggle="collapse" data-parent="#accordion_2" href="#collapse_2">
                <p>MySurprise</p>
                <i class="fa fa-chevron-down"></i>
              </a>
            </div>
            <div id="collapse_2" class="collapse">
              <div class="" id="accordion2_1">
                <div class="accord_subtitle first">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion2_1"
                     href="#collapse_2_1">
                    <p>Hoe log ik in op MySurprise?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_2_1" class="collapse in">
                  <div class="accord_body">
                    <p>Wanneer je een MySurprise account hebt aangemaakt kun je bovenaan rechts op de pagina inloggen door op Mijn Account te klikken. Voer vervolgens je mobiele nummer in en je wachtwoord en je kunt van start! Heb je nog geen MySurprise account?
                      Klik dan <a href="#" @click.prevent="registerPopup()">hier</a>
                      om deze nu aan te maken.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion2_2">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion2_2"
                     href="#collapse_2_2">
                    <p>Wat is MySurprise?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_2_2" class="collapse in">
                  <div class="accord_body">
                    <p>Met je MySurprise account heb je toegang tot je eigen Prepaid Surprise omgeving. In MySurprise zie je een overzicht van alle speelcodes die je nog kunt gebruiken, je gebruikte speelcodes en de prijzen die je in het verleden hebt gewonnen.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion2_3">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion2_3"
                     href="#collapse_2_3">
                    <p>Wat zijn de voordelen van MySurprise?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_2_3" class="collapse in">
                  <div class="accord_body">
                    <p>Met een MySurprise account heb je toegang tot je eigen Prepaid Surprise omgeving. Hiermee:</p>
                    <br>
                    <ul>
                      <li>Heb je een overzicht van alle speelcodes die je nog kunt gebruiken, je gebruikte codes en de prijzen die je hebt gewonnen.</li>
                      <li>Hoef je maar één keer akkoord te gaan met de algemene voorwaarden (anders moet je iedere keer dat je speelt je akkoord geven).</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="accord_outer" id="accordion_3">
            <div class="accord_title">
              <a class="d-flex flex-row justify-content-between align-items-center"
                 data-toggle="collapse" data-parent="#accordion_3" href="#collapse_3">
                <p>Speelcodes en Bonuscodes</p>
                <i class="fa fa-chevron-down"></i>
              </a>
            </div>
            <div id="collapse_3" class="collapse">
              <div class="" id="accordion3_1">
                <div class="accord_subtitle first">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion3_1"
                     href="#collapse_3_1">
                    <p>Hoelang is mijn code geldig?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_3_1" class="collapse in">
                  <div class="accord_body">
                    <p>Vanaf het moment dat je de speelcode hebt ontvangen is deze 14 dagen geldig. Je ontvangt tussentijds ook nog een herinnerings-sms als je de code binnen de 14 dagen nog niet hebt gebruikt.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion3_2">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion3_2"
                     href="#collapse_3_2">
                    <p>Wanneer ontvang ik mijn speelcode?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_3_2" class="collapse in">
                  <div class="accord_body">
                    <p>Binnen een half uur nadat je opgewaardeerd hebt ontvang je per sms je speelcode. Het kan soms wat langer duren, maar meestal niet langer dan twee uur.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion3_3">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion3_3"
                     href="#collapse_3_3">
                    <p>Ik heb mijn speelcode nog niet ontvangen, wat kan ik doen?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_3_3" class="collapse in">
                  <div class="accord_body">
                    <p>Er kunnen verschillende redenen zijn dat je je code niet hebt ontvangen:</p>
                    <br>
                    <ul>
                      <li>Je hebt aangegeven geen commerciële sms'jes te willen ontvangen. In dat geval kun je via je Odido omgeving dit weer zelf aanzetten. Klik <a href="#" @click.prevent="loginPopup">hier</a> om dit direct te regelen. Je zult vanaf dat moment de speelcodes weer ontvangen. Speelcodes uit het verleden worden niet opnieuw toegestuurd.
                      </li>
                      <li>Je hebt je uitgeschreven voor Prepaid Surprise. Om je weer voor het spel aan te melden hoef je alleen maar een MySurprise account aan te maken. Je zult bij je volgende opwaardering weer speelcodes ontvangen. Wil je geen MySurprise account maar wel meespelen? Stuur gratis een sms met AANMELDEN naar 1616.</li>
                      <li>Gelden bovenstaande gevallen niet? Kijk dan in je MySurprise account naar je overzicht, daar staan al je codes weergegeven. Nog geen MySurprise account? Dan kun je <a href="#" @click.prevent="lostCodesPopup">hier</a> je code opnieuw laten opsturen.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="" id="accordion3_4">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion3_4"
                     href="#collapse_3_4">
                    <p>Wat moet ik doen als mijn speelcode niet werkt?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_3_4" class="collapse in">
                  <div class="accord_body">
                    <p>Het kan zijn dat je een speelcode invoert en het spel niet start. Controleer in zo'n geval of je wel de juiste speelcode en mobiele nummer hebt ingevoerd of dat je speelcode niet verlopen is. Je speelcode is nog 14 dagen geldig nadat je deze hebt ontvangen. Ook kun je in je MySurprise account precies zien wat de status is van je ontvangen speelcodes. Mocht het nog steeds niet lukken, neem dan contact op met onze service via telefoonnummer 0800-0092 of via <a href="https://www.odido.nl/service" target="_blank">https://www.odido.nl/service</a>.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion3_5">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion3_5"
                     href="#collapse_3_5">
                    <p>Kan ik mijn speelcode vaker dan één keer gebruiken?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_3_5" class="collapse in">
                  <div class="accord_body">
                    <p>Je kunt je speelcode slechts één keer gebruiken om het spel te spelen.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion3_6">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion3_6"
                     href="#collapse_3_6">
                    <p>Kan ik mijn speelcode ook gebruiken in combinatie met een ander telefoonnummer?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_3_6" class="collapse in">
                  <div class="accord_body">
                    <p>De speelcode werkt alleen in combinatie met het telefoonnummer waarmee je de bundel hebt gekocht of hebt opgewaardeerd.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion3_7">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion3_7"
                     href="#collapse_3_7">
                    <p>Ik heb een bonuscode ontvangen. Hoe werkt dit?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_3_7" class="collapse in">
                  <div class="accord_body">
                    <p>Om de zoveel tijd heeft Odido speciale acties waarbij je bonuscodes kunt ontvangen en dus een extra kans krijgt om prijzen te winnen.</p>
                    <p>Je bonuscode wordt in een aparte sms naar je verstuurd. Deze werkt net als je normale speelcodes.</p>
                    <p>Hoe je je code gebruikt lees je onder "Hoe speel ik mee met Prepaid Surprise" in de veel gestelde vragen. Of ga naar "Hoe werkt het". (Afhankelijk van de actie geeft de bonuscode je wel of geen keuze van een surprise).</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="accord_outer" id="accordion_4">
            <div class="accord_title">
              <a class="d-flex flex-row justify-content-between align-items-center"
                 data-toggle="collapse" data-parent="#accordion_4" href="#collapse_4">
                <p>Hoofdprijzen & Surprises</p>
                <i class="fa fa-chevron-down"></i>
              </a>
            </div>
            <div id="collapse_4" class="collapse">
              <div class="" id="accordion4_1">
                <div class="accord_subtitle first">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion4_1"
                     href="#collapse_4_1">
                    <p>Win ik altijd als ik een bundel heb gekocht of heb opgewaardeerd?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_4_1" class="collapse in">
                  <div class="accord_body">
                    <p>Ja, je wint gegarandeerd een leuke Odido surprise die je ook nog eens zelf mag uitkiezen. Maar als eerste maak je kans op fantastische hoofdprijzen. De hoofdprijzen veranderen iedere maand. Je kunt er ook voor kiezen om je Odido surprise te laten vervallen en in te zetten voor een extra draai aan het rad, om nog een keer kans te maken op één van de fantastische hoofdprijzen. Je kan natuurlijk met net zoveel speelcodes meedoen als je zelf wil.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion4_2">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion4_2"
                     href="#collapse_4_2">
                    <p>Hoe ontvang ik mijn Odido surprise en/of hoofdprijs?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_4_2" class="collapse in">
                  <div class="accord_body">
                    <p>De Odido surprise die je kiest (bijv. extra belminuten, sms'jes, MB of Prepaid tegoed) wordt automatisch aan je Prepaid tegoed toegevoegd. Op dat moment ontvang je van ons een sms ter bevestiging. Meestal gebeurt dit binnen een uur, in uitzonderlijke gevallen kan dit tot een dag duren. Wanneer je één van de hoofdprijzen wint, vragen we je om je gegevens zodat we de prijs zo snel mogelijk naar je kunnen versturen. Let op! Voor het spelen van Prepaid Surprise moet je 18 jaar of ouder zijn, óf toestemming van je ouders hebben.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion4_3">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion4_3"
                     href="#collapse_4_3">
                    <p>Hoelang duurt het voordat mijn gewonnen hoofdprijs wordt thuisbezorgd?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_4_3" class="collapse in">
                  <div class="accord_body">
                    <p>Je prijs wordt zo snel mogelijk thuisbezorgd als je adres- en contactgegevens goed zijn ingevuld. Controleer dit dus goed! Mocht je tot twee keer toe niet thuis zijn, dan kun je op vertoon van een geldig legitimatiebewijs je prijs bij een postkantoor in de buurt ophalen. Let op: PostNL laat geen briefje achter als je er niet bent. Controleer jouw bezorgstatus in de PostNL app.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion4_4">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion4_4"
                     href="#collapse_4_4">
                    <p>Is je hoofdprijs beschadigd of heb je niet de juiste hoofdprijs ontvangen?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_4_4" class="collapse in">
                  <div class="accord_body">
                    <p>Neem zo snel mogelijk contact op met onze klantenservice, dan gaan wij het voor je oplossen.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion4_5">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion4_5"
                     href="#collapse_4_5">
                    <p>Kunnen hoofdprijzen ook buiten Nederland bezorgd worden?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_4_5" class="collapse in">
                  <div class="accord_body">
                    <p>Helaas kunnen de prijzen alleen binnen Nederland bezorgd worden.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion4_6">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion4_6"
                     href="#collapse_4_6">
                    <p>Hoe kan ik zien wat ik in het verleden heb gewonnen?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_4_6" class="collapse in">
                  <div class="accord_body">
                    <p>Wanneer je een MySurprise account aanmaakt kun je daar een overzicht van al je gewonnen prijzen zien. Ook kun je zien met welke speelcodes je nog kunt spelen en welke speelcodes nog niet afgerond zijn.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion4_7">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion4_7"
                     href="#collapse_4_7">
                    <p>Wat kan ik winnen?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_4_7" class="collapse in">
                  <div class="accord_body">
                    <p>Iedere maand geeft Odido nieuwe hoofdprijzen weg met Prepaid Surprise. Dit kunnen reizen zijn, scooters, uitjes, tablets, smartphones, leuke gadgets, tegoedbonnen en veel meer. Heb je geen hoofdprijs gewonnen? Niet getreurd, want bij Prepaid Surprise krijg je altijd de keuze uit verschillende surprises. Dit kunnen bijvoorbeeld extra sms'jes, MB of belminuten zijn. Een compleet overzicht van de prijzen vind op de hoofdpagina.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion4_8">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion4_8"
                     href="#collapse_4_8">
                    <p>Ik vind mijn hoofdprijs niet zo leuk. Kan ik een andere hoofdprijs uitkiezen?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_4_8" class="collapse in">
                  <div class="accord_body">
                    <p>Helaas, je hoofdprijs kan niet voor een andere hoofdprijs worden ingeruild.</p>
                  </div>
                </div>
              </div>

              <div class="" id="accordion4_9">
                <div class="accord_subtitle">
                  <a class="d-flex" data-toggle="collapse" data-parent="#accordion4_9"
                     href="#collapse_4_9">
                    <p>Ik heb belminuten, sms’jes of MB's gewonnen. Wat houdt dit in?</p>
                    <i class="fa fa-chevron-down ml-auto"></i>
                  </a>
                </div>
                <div id="collapse_4_9" class="collapse in">
                  <div class="accord_body">
                    <p>De belminuten, sms’jes of MB's die je hebt gewonnen zijn 7 dagen geldig en worden als eerste van je tegoed gebruikt. Deze zijn alleen binnen Nederland geldig en servicenummers zijn uitgesloten. Bij een opwaardering van meer dan € 20 of koop je via iDEAL een <a href="https://www.odido.nl/mobiel-abonnement/prepaid-sim-only/bundels" target="_blank" rel="noopener">bundel</a> van € 20 of meer, dan kun je ook de Odido Surprise, gratis promo-tegoed kiezen. Met dit tegoed kun je bellen in Nederland (servicenummers zijn uitgesloten) en ook kun je van dit tegoed bundels kopen.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="faq_link" @click.prevent="goToOptOut()">
        <span class="arrow_blue"><a href="">Afmelden voor Prepaid Surprise</a></span>
      </div>

      <opt-out-popup v-if="optOutModalOpen()"></opt-out-popup>
      <popup-register v-if="registerModal"></popup-register>
      <login-popup v-if="loginModal"></login-popup>
      <lostcodes-popup v-if="lostCodesModal"></lostcodes-popup>

    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  import OptOut from './modals/OptOut'
  import Register from './modals/Register'
  import Login from './modals/Login'
  import LostCode from './modals/LostCode'
  import gameFlow from "../common/mixin/gameFlow";
  import gtm_analytics from "../common/mixin/gtm_analytics";

  export default {
    name: 'Faq',
    mixins: [
      gameFlow,
      gtm_analytics
    ],
    components: {
      'popup-register': Register,
      'opt-out-popup': OptOut,
      'login-popup': Login,
      'lostcodes-popup': LostCode
    },
    computed: {
      ...mapGetters([
        'isRegisterModalOpen',
        'isOptOutModalOpen',
        'isLostCodeModalOpen',
        'isLoginModalOpen'
      ]),
      registerModal() {
        return this.isRegisterModalOpen
      },
      loginModal() {
        return this.isLoginModalOpen
      },
      lostCodesModal() {
        return this.isLostCodeModalOpen
      }
    },
    mounted() {
      let faflagAcc = 1
      $(this).find('.ml-auto').click(function () {
        if (faflagAcc === 1) {
          $(this).find('i').toggleClass('fa-chevron-down')
          $(this).find('i').toggleClass('fa-chevron-up')
          faflagAcc = 2
        } else {
          $(this).find('i').removeClass('fa-chevron-up')
          $(this).find('i').addClass('fa-chevron-down')
          faflagAcc = 1
        }
      })
      this.setInGameFlow("false", this.$route.params)
    },
    methods: {
      ...mapMutations([
        'updateRegisterModal',
        'updateOptOutModal',
        'updateLoginModal',
        'updateLostCodeModal'
      ]),

      registerPopup() {
        this.updateRegisterModal(true)
      },

      optOutModalOpen() {
        return this.isOptOutModalOpen
      },

      goToOptOut() {
        this.updateOptOutModal(true)
      },
      loginPopup() {
        this.updateLoginModal(true)
      },
      lostCodesPopup() {
        this.updateLostCodeModal(true)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FAQ.vue